module.exports = __webpack_public_path__ + "img/accessory_pants_09.81b4e6d8.svg";